import { render, staticRenderFns } from "./DisqualificationApply.vue?vue&type=template&id=276804c8&scoped=true"
import script from "./DisqualificationApply.vue?vue&type=script&lang=js"
export * from "./DisqualificationApply.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationApply.vue?vue&type=style&index=0&id=276804c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276804c8",
  null
  
)

export default component.exports